import { Pipe, PipeTransform } from '@angular/core';
import { GridColumn, GridItem } from '../grid-control.model';
@Pipe({
  name: 'editorSubInformationHandler'
})
export class EditorSubInformationHandlerPipe implements PipeTransform {
  transform(value: any, item: GridItem, columns: GridColumn[]): boolean {
    const visible = (column: GridColumn) => {
      if (column.type === 'children') {
        return false;
      }
      let isDisabled = false;

      // Kiểm tra xem có bị disabled hay không?
      if (column.editor) {
        isDisabled = typeof (column.editor.disabled) === 'function' ? column.editor.disabled(item) : column.editor.disabled;
      }
      // Nếu bị disabled return false
      if (isDisabled) {
        return false;
      }
      // Nếu bị disabled return false
      if (isDisabled) {
        return false;
      }

      // Hiển thị editor nếu dòng đó:
      // Đang được edit: editingStatus
      return item.editingStatus
        // Được thiết lập alwayDisplay
        || (column.editor && column.editor.alwayDisplay);
    };
    item.editorHandler = item.editorHandler || {};
    for (const column of columns) {
      item.editorHandler.disabled = false;
      item.editorHandler[column.field] = {};

      if (item.editorHandler.disabled) {
        item.editorHandler[column.field].visible = false;
      } else {
        item.editorHandler[column.field].visible = visible(column);
      }
    }
    return true;
  }
}
